import { route } from 'preact-router'

const itemPath = item => {
  switch (item.actionTarget) {
    case 'guide':
      route(`${__webpack_public_path__ || '/'}live`)

      break
    case 'login':
      route(`${__webpack_public_path__ || '/'}auth/login`)
      break
    case 'account':
      route(`${__webpack_public_path__ || '/'}account`)

      break
    case 'dvr':
      route(`${__webpack_public_path__ || '/'}dvr`)
      break
    case 'video_library':
      route(`${__webpack_public_path__ || '/'}video-library`)
      break
    case 'video_library_category':
      route(`${__webpack_public_path__ || '/'}video-category/${item.actionId}`)
      break
    case 'checkout':
      route(`${__webpack_public_path__ || '/'}checkout`)

      break
    case 'support':
      route(`${__webpack_public_path__ || '/'}support`)

      break
    case 'search':
      route(`${__webpack_public_path__ || '/'}search`)

      break
    case 'home':
      route(`${__webpack_public_path__ || '/'}`)

      break
    case 'youtube':
      route(`${__webpack_public_path__ || '/'}youtube`)

      break
    case 'settings':
      route(`${__webpack_public_path__ || '/'}settings`)
      break
    case 'external_url':
      window.location.href = item.actionUrl
      break
    case 'external_url_iframe':
      route(`${__webpack_public_path__ || '/'}external/${item.id}`)
      break
    default:
  }
}

export default itemPath
